<script lang="ts">
	import { _ } from "svelte-i18n";
	import { Toast, ToastBody, ToastHeader } from "@sveltestrap/sveltestrap";
	import { dismissToast, toasts, type ToastVariant } from "../store/toasts";

	function headerKey(variant: ToastVariant): string {
		switch (variant) {
			case "info":
				return "landingpage.toast.info";
			case "success":
				return "landingpage.toast.success";
			case "warning":
				return "landingpage.toast.warning";
			case "danger":
				return "landingpage.toast.error";
		}
	}
</script>

<!--
	Mount this component exactly once globally (see App.svelte).
	`aria-live="polite"` is intentional even for danger toasts: a single container
	keeps the markup simple, and toast messages are short enough that delayed
	announcement is acceptable. Split into polite/assertive containers if user
	feedback shows otherwise.
-->
<div class="toast-container position-fixed top-0 end-0 p-3" aria-live="polite" aria-atomic="true">
	{#each $toasts as toast (toast.id)}
		<Toast isOpen={true} class="mb-2 text-bg-{toast.variant}">
			<ToastHeader toggle={() => dismissToast(toast.id)}>
				{$_(headerKey(toast.variant))}
			</ToastHeader>
			<ToastBody>{toast.message}</ToastBody>
		</Toast>
	{/each}
</div>
